import { useCallback, useEffect, useState } from 'react';
import { fetchPresupuestosActivos } from '../services/presupuestos';

export function usePresupuestosActivos() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const cargar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await fetchPresupuestosActivos();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { items, isLoading, error, recargar: cargar };
}
